import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { OrganizationDto, ResponseDto } from "@mimber/schema"
import { organizationsKeys } from "../organizations.utils"

/**
 * Organization-specific hook for fetching all organizations a user belongs to
 * Can only be used in mimber-organization app
 */
export const useOrganizations = (
  options?: Omit<
    UseQueryOptions<ResponseDto<OrganizationDto[]>, Error>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<ResponseDto<OrganizationDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useOrganizations")

  const { server } = useServerContext()

  return useQuery({
    queryKey: organizationsKeys.findAll(),
    queryFn: async () => {
      const response =
        await server.get<ResponseDto<OrganizationDto[]>>("organizations")
      return response.data
    },
    staleTime: 10 * 60 * 1000,
    ...options,
  })
}
